import "../../../assets/css/dashboard.css";

import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DateTime } from "luxon";
import EmptyGif from "../../../assets/images/illustrations/empty.gif";
import FolderIcon from "../../../assets/images/illustrations/12_folder.png";
import FooterDisplay from "../../../components/footer";
import { fetchData, profileData } from "../../../slices/profileSlice";
import AllAppRoutes from "../../../common/routes";
import {
  _become_ra_update,
  _confirm_user_transfer_pin,
  _generate_otp,
  _get_profile,
  _update_profile,
  _user_dashboard_referrals,
  _verify_otp,
} from "../../../common/axios_services";
import { useDispatch, useSelector } from "react-redux";
import {
  Drawer,
  Spin,
  Switch,
  Upload,
  notification,
  Modal,
  Result,
} from "antd";
import RequestTransactionCode from "../../../components/profile/transcode";
import AppRoutes from "../../../common/routes";
import { persistor } from "../../../store";
import { message } from "antd";
import { CopyOutlined, LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import { AccountHeader } from "../../../components/AccountHeader";
import CopyToClipboard from "react-copy-to-clipboard";
import { QRCodeCanvas } from "qrcode.react";
import ImpersonationAccessDeniedModal from "../../../components/ImpersonationAccessDeniedModal";

const ProfileSettings = () => {
  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const [jwt] = useState(localStorage.getItem("konnect_token"));

  const newAntIcon = <LoadingOutlined style={{ fontSize: 40 }} spin />;

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      description: message,
    });
  };

  const [referralSummary, setReferralSummary] = useState({});
  const [loadingSpinner, setLoadingSpinner] = useState(true);
  const [userData, setUserData] = useState({});
  const [displayTransCodeModal, setDisplayTransCodeModal] = useState(false);
  const [userPin, setUserPin] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [transCodeDrawer, setTransCodeDrawer] = useState(false);
  const [otpCounter, setOtpCounter] = useState(false);
  const [userType, setUserType] = useState("basic");
  const [imageUploadError, setImageUploadError] = useState(false);
  const [displaySalesAgentMessage, setDisplaySalesAgentMessage] =
    useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [imageUpload, setImageUpload] = useState({});
  const [loading, setLoading] = useState(false);
  const [displayPageLoader, setDisplayPageLoader] = useState(false);
  const [displayUpdateProfilePicModal, setdisplayUpdateProfilePicModal] =
    useState(false);
  const [referralModalOpen, setReferralModalOpen] = useState(false);

  /* Referral DRAWER */
  const showPartnerModal = () => {
    setReferralModalOpen(true); //signed in but not a vendor
  };
  // is not vendor
  const handleReferralCancel = () => {
    setReferralModalOpen(false);
  };

  const toggleTransactionCodeDrawer = () => {
    setTransCodeDrawer(!transCodeDrawer);
  };
  const toggleTransCodeModalDisplay = () => {
    setDisplayTransCodeModal(!displayTransCodeModal);
    setOtpCounter(true);
  };
  const fetchUser = async () => {
    try {
      const user_profile = await _get_profile();
      dispatch(fetchData(true));
      dispatch(profileData(user_profile?.data?.data));
      let userData = user_profile?.data.data;
      setUserData(userData);
      setUserType(userData.is_ra ? "ra" : "basic");
      setLoadingSpinner(false);
      // console.log(userData);
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          Navigate(`/signin`);
        }
        dispatch(profileData(false));
        dispatch(fetchData(false));
      } else {
      }
      setLoadingSpinner(false);
    }
  };
  useEffect(() => {
    if (jwt) {
      fetchUser();
      // getReferralSummary();
    } else {
      setLoadingSpinner(false);
    }
  }, []);

  const logout = async () => {
    try {
      localStorage.clear();
      await persistor.purge();
      dispatch(fetchData(false));
      dispatch(profileData(false));
      openNotificationWithIcon(
        "success",
        "You have been logged out successfully",
      );
      Navigate("/signin");
    } catch (error) {
      Navigate("/signin");
    }
  };

  const sendOTPToUser = async () => {
    setLoadingSpinner(true);
    try {
      const generate_otp = await _generate_otp();
      openNotificationWithIcon("success", generate_otp?.data?.message);
      setLoadingSpinner(false);
      toggleTransCodeModalDisplay();
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          openNotificationWithIcon("error", err?.response?.data?.message);
          Navigate("/signin");
        }
        openNotificationWithIcon("error", err?.response?.data?.message);
      } else {
        openNotificationWithIcon("error", err.message);
      }
      setLoadingSpinner(false);
    }
  };

  const VerifyOtp = async () => {
    setLoadingSpinner(true);
    try {
      const verifyOtp = await _verify_otp({ otp: userPin });
      setLoadingSpinner(false);
      openNotificationWithIcon("success", verifyOtp?.data?.message);
      toggleTransactionCodeDrawer();
    } catch (err) {
      setLoadingSpinner(false);
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          openNotificationWithIcon(
            err?.response?.data?.status,
            err?.response?.data?.message,
          );
          Navigate("/signin");
        } else {
          openNotificationWithIcon(
            err?.response?.data?.status,
            err?.response?.data?.message,
          );
        }
      } else {
        openNotificationWithIcon("error", err.message);
      }
    }
  };

  const verifyUserPin = async (e) => {
    setLoadingSpinner(true);
    toggleTransCodeModalDisplay();
    setDisplayTransCodeModal(false);
    try {
      const profile = await _confirm_user_transfer_pin(e);
      toggleTransactionCodeDrawer();
      setLoadingSpinner(false);
    } catch (err) {
      if (err?.response?.data?.message) {
        if (err?.code === "ERR_NETWORK") {
          openNotificationWithIcon(
            "error",
            "An error occurred while checking pin. Please check network and try again",
          );
        } else if (err?.response?.data?.message === "Unauthorized") {
          openNotificationWithIcon(
            "error",
            "User Authorization expired. Please log in to continue",
          );
          Navigate("/signin");
        } else {
          openNotificationWithIcon(
            "error",
            err?.data?.message.length
              ? err?.data?.message
              : err?.response?.data?.message,
          );
        }
      } else {
        openNotificationWithIcon(
          "error",
          "An error occurred while checking pin. Please try again",
        );
      }
      setLoadingSpinner(false);
    }
  };

  const updateUserType = async () => {
    setLoadingSpinner(true);
    try {
      const changeType = await _become_ra_update({ status: !userData.is_ra });
      setLoadingSpinner(false);
      openNotificationWithIcon("success", changeType?.data?.message);
      let currType = userData.is_ra;
      if (currType) {
        setUserType("basic");
      } else {
        setUserType("ra");
      }
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          openNotificationWithIcon(
            err?.response?.data?.status,
            err?.response?.data?.message,
          );
          Navigate("/signin");
        } else {
          openNotificationWithIcon(
            err?.response?.data?.status,
            err?.response?.data?.message,
          );
        }
      } else {
        openNotificationWithIcon("error", err.message);
      }
    }
    setLoadingSpinner(false);
  };

  const props = {
    name: "file",
    action: "https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload",
    headers: {
      authorization: "authorization-text",
    },
    onChange(info) {
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        // message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        // message.error(`${info.file.name} file upload failed.`);
      }
    },
  };

  //   const handleChange = (info) => {
  //     getBase64(
  //       info.file.originFileObj,
  //       (imageUrl) => setImageUrl(imageUrl),
  //       setLoading(false)
  //     );
  //     const reader = new FileReader();

  //     reader.readAsDataURL(info.file.originFileObj);
  //     reader.addEventListener("load", () => {
  //       setImageToSend(reader.result);
  //     });
  //   };

  const toggleSalesAgentMessage = () => {
    setDisplaySalesAgentMessage(!displaySalesAgentMessage);
  };

  const beforeUpload = (file) => {
    setImageUploadError(false);
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      setImageUploadError(true);
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      setImageUploadError(true);
      message.error("Image must smaller than 5MB!");
    }
    // return isJpgOrPng && isLt2M;
    return false;
  };

  const getBase64 = (img) => {
    const file = img;
    const reader = new FileReader();

    reader.addEventListener("load", () => {
      setImageUrl(reader.result);
    });

    if (!imageUploadError) {
      if (file) {
        reader.readAsDataURL(file);
      }
    }
  };

  const handleChange = (info) => {
    getBase64(info.file);
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </div>
  );

  const UpdateProfilePicFunct = async () => {
    if (imageUrl) {
      setLoadingSpinner(true);
      setdisplayUpdateProfilePicModal(false);
      try {
        const data = {
          first_name: userData.firstName,
          last_name: userData.lastName,
          email: userData.email,
          phone_number: userData.phoneNumber,
          //   userType: userData.userType,
          gender: userData.gender,
          dob: userData.dob,
          image: imageUrl,
          pin: userData.pin,
          age: userData.age,
        };
        const updateProfile = await _update_profile(data);
        setLoadingSpinner(false);
        Navigate(0);
        openNotificationWithIcon("success", "Profile updated successfully");
      } catch (err) {
        if (err.response) {
          if (err.response.data.message === "Unauthorized") {
            localStorage.removeItem("konnect_token");
            Navigate("/signin");
            // setProfileErr(false)
            openNotificationWithIcon("error", err.message);
          } else {
            // setProfileErr(err.response.data.message)
            openNotificationWithIcon("error", err.response.data.message);
          }
        } else {
          openNotificationWithIcon("error", err.message);
        }
        setLoadingSpinner(false);
      }
    } else {
      openNotificationWithIcon("error", "Please select an image");
    }
  };

  const deleteProfilePicFunct = async () => {
    setLoadingSpinner(true);
    try {
      const data = {
        ...userData,
        image: "",
      };
      const updateProfile = await _update_profile(data);
      setLoadingSpinner(false);
      Navigate(0); // Refresh page
      openNotificationWithIcon(
        "success",
        "Profile picture deleted successfully",
      );
      setImageUrl("");
    } catch (err) {
      if (err.response && err.response.data.message === "Unauthorized") {
        localStorage.removeItem("konnect_token");
        Navigate("/signin");
      }
      openNotificationWithIcon(
        "error",
        err.response?.data?.message || err.message,
      );
      setLoadingSpinner(false);
    }
  };

  const referralCode = userData?.accountId || "";
  const referralLink = `https://konnect.ws/?konnectrfc=${referralCode}`;

  return (
    <Spin spinning={loadingSpinner} indicator={newAntIcon}>
      <ImpersonationAccessDeniedModal />
      <div className="profile-display settings-display">
        <div className="settings-detail-summary">
          {jwt ? (
            <>
              {/* <div className="small-page-title contain">
                  <div className="grid-flex">
                      <div
                          onClick={() => Navigate(-1)}>
                          <ion-icon name="arrow-back-circle"></ion-icon>
                      </div>
                  </div>
              </div> */}
              <div>
                <AccountHeader
                  userData={userData}
                  updateHandle={setdisplayUpdateProfilePicModal}
                  handleDrawer={showPartnerModal}
                />
              </div>
              <div className="settings-list-display ">
                <div className="settings-list">
                  <div className="settings-inner-list">
                    <div>
                      <ul>
                        <li>
                          <Link to={AppRoutes.basic_profile}>
                            <p>Update Basic Information</p>
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </Link>
                        </li>
                        <li>
                          <Link to="/profile/security-settings">
                            <p>Security Settings</p>
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </Link>
                        </li>
                        {/* {!userData?.business && (
                          <li>
                            <Link to={AppRoutes.become_business}>
                              <p>Become a Business</p>
                              <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                          </li>
                        )} */}
                        {userData.isBiker && (
                          <li>
                            <Link to={AppRoutes.delivery}>
                              <p>My Delivery Portal</p>
                              <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                          </li>
                        )}
                        <li>
                          <Link to={AppRoutes.profile_referral}>
                            <p>Referral Information</p>
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </Link>
                        </li>
                        {/* <li>
                          <Link to="/fourward">
                            <p>Personal 4Ward</p>
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </Link>
                        </li> */}
                        {/* <li>
                          <Link to="/group-account">
                            <p>Group Account</p>
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </Link>
                        </li> */}
                        {/* {!userData.isAmbassador && (
                          <li>
                            <Link to={AppRoutes.become_ambassador}>
                              <p>Become an Ambassador</p>
                              <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                          </li>
                        )} */}
                        {userData.role === "SUPPORT_MANAGER" && (
                          <li>
                            <Link to={AppRoutes.support}>
                              <p className="font-bold">My SM Portal</p>
                              <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                          </li>
                        )}
                        {userData.role === "SUPPORT_OFFICER" && (
                          <li>
                            <Link to={AppRoutes.supportOfficer}>
                              <p className="font-bold">My SO Portal</p>
                              <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                          </li>
                        )}
                        {userData.role === "SUPPORT_EXECUTIVE" && (
                          <li>
                            <Link to={AppRoutes.supportExecutive}>
                              <p className="font-bold">My SE Portal</p>
                              <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                          </li>
                        )}
                        {userData.business && (
                          <li>
                            <Link to={AppRoutes.restaurant_dashboard}>
                              <p className="font-bold">My Business Dashboard</p>
                              <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                          </li>
                        )}
                        {userData.role === "ADMIN" && (
                          <li>
                            <Link to="/admin/dashboard">
                              <p className="font-bold">My Admin Dashboard</p>
                              <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                          </li>
                        )}
                        {userData.is_sa ? (
                          <li>
                            <Link to="/profile/sales-report">
                              <p>View Sales Report</p>
                              <ion-icon name="chevron-forward-outline"></ion-icon>
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}
                      </ul>
                    </div>
                  </div>
                  <div className="settings-inner-list">
                    <div>
                      <ul>
                        <li>
                          <Link to={AppRoutes.terms}>
                            <p>Terms of Use</p>
                            {/* <ion-icon name="chevron-forward-outline"></ion-icon> */}
                          </Link>
                        </li>
                        <li>
                          <Link to={AppRoutes.privacy}>
                            <p>Privacy Policies</p>
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </Link>
                        </li>
                        <li>
                          <Link
                            style={{ color: "#A9411D" }}
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              logout();
                            }}
                          >
                            <p>Sign Out</p>
                            <ion-icon name="chevron-forward-outline"></ion-icon>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div
                style={{
                  textAlign: "center",
                  marginTop: 40,
                  fontSize: "1.3rem",
                }}
              >
                <p>
                  User since{" "}
                  {DateTime.fromISO(userData.createdAt).toLocaleString(
                    DateTime.DATE_HUGE,
                  )}
                </p>
              </div>
            </>
          ) : (
            <div className="center-content short mt_5">
              <div className="center-content-text">
                <img src={FolderIcon} alt="folder" />
                <h4>Create a Konnect Account</h4>
                <p>
                  Konnect allows you to enjoy instant and monthly cash reward
                  from product offers and commision when you refer friends.
                  Sign-up now to get started.
                </p>
                <div>
                  <div className="">
                    <Link className="btn-base" to={AllAppRoutes.signup}>
                      Create account now
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        <RequestTransactionCode
          openDrawer={displayTransCodeModal}
          closeDrawer={toggleTransCodeModalDisplay}
          inputCount={4}
          actionFunction={verifyUserPin}
          stateFunc={setUserPin}
        />

        {/*View Referral Code Drawer*/}
        <Drawer
          open={referralModalOpen}
          footer={null}
          onClose={handleReferralCancel}
          placement="bottom"
          className="partnerModal"
        >
          <div className="flex flex-col px-8 gap-y-5">
            <h2 className="text-green-800 text-5xl my-4">Referral Code</h2>

            {/* 1. Referral Code */}
            <div>
              <span>Referral code: </span>
              <CopyToClipboard
                text={referralCode}
                onCopy={() =>
                  message.success("Referral Code copied to clipboard!")
                }
              >
                <span
                  style={{
                    cursor: "pointer",
                    color: "#000",
                    fontWeight: "bold",
                  }}
                >
                  {referralCode}
                  <CopyOutlined
                    style={{ marginLeft: "20px", fontSize: "16px" }}
                  />
                </span>
              </CopyToClipboard>
            </div>

            {/* 2. Dynamic Web Link */}
            <div>
              <span>Referral link: </span>
              <CopyToClipboard
                text={referralLink}
                onCopy={() =>
                  message.success("Referral Link copied to clipboard!")
                }
              >
                <span
                  style={{
                    cursor: "pointer",
                    color: "#1d4ed8",
                    textDecoration: "underline",
                    fontWeight: "bold",
                  }}
                >
                  {referralLink}
                  <CopyOutlined
                    style={{ marginLeft: "10px", fontSize: "16px" }}
                  />
                </span>
              </CopyToClipboard>
            </div>

            {/* 3. QR Code */}
            <div>
              <span>My unique QR Code:</span>
              <div className="mt-4 flex items-center justify-center ">
                <QRCodeCanvas value={referralLink} size={134} level="H" />
              </div>
            </div>
          </div>
        </Drawer>

        <Drawer
          footer={null}
          onClose={toggleTransactionCodeDrawer}
          open={transCodeDrawer}
          placement="bottom"
        >
          <div className="modal-disp">
            <div className="extra-detail">
              <div className="contain">
                <ul>
                  <li className="grid-flex">
                    <span>Email address</span>
                    <span>{userData.email}</span>
                  </li>
                  <li className="grid-flex">
                    <span>Phone number</span>
                    <span>
                      {userData.phoneCode}
                      {userData.phoneNumber}
                    </span>
                  </li>
                  <li className="grid-flex">
                    <span>Referral code</span>
                    <span>{userData.accountId}</span>
                  </li>
                  <li className="grid-flex">
                    <span>Transaction code</span>
                    <span>{userData.pin}</span>
                  </li>
                </ul>
                <button
                  onClick={toggleTransactionCodeDrawer}
                  className="btn btn-red"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </Drawer>
        <Drawer
          footer={null}
          onClose={toggleSalesAgentMessage}
          open={displaySalesAgentMessage}
          placement="bottom"
        >
          <div className="modal-disp empty">
            <div className="extra-detail">
              <div className="contain">
                <img
                  src={EmptyGif}
                  alt="empty illustrations"
                  className="empty-illustration"
                />
                <p>
                  Join us as a Sales agent to generate your electronic identity
                  data (e-ID)
                </p>
                <Link
                  to={AppRoutes.partner}
                  style={{ display: "block", textAlign: "center" }}
                  className="btn btn-red"
                >
                  Join Us
                </Link>
              </div>
            </div>
          </div>
        </Drawer>
        <Drawer
          footer={null}
          onClose={() => setdisplayUpdateProfilePicModal(false)}
          open={displayUpdateProfilePicModal}
          placement="bottom"
        >
          <div>
            <div className="form-drawer-title">
              <div>
                <h3>Update Picture</h3>
              </div>
              <div>
                <div
                  onClick={() => setdisplayUpdateProfilePicModal(false)}
                  className="cancel-bar"
                >
                  <ion-icon name="close-outline"></ion-icon>
                </div>
              </div>
            </div>
            <div className="contain mt_4">
              <div
                className=""
                style={{ width: "max-content", margin: "0px auto" }}
              >
                <Upload
                  name="avatar"
                  multiple={false}
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  beforeUpload={beforeUpload}
                  onChange={handleChange}
                >
                  {imageUrl?.length ? (
                    <img
                      src={imageUrl}
                      alt="avatar"
                      style={{
                        width: "100%",
                      }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              </div>
              <div className="mt_3">
                <div>
                  <button
                    onClick={UpdateProfilePicFunct}
                    className="btn btn-primary"
                  >
                    Update Profile Picture
                  </button>
                </div>
                <div className="my-5">
                  {/* Delete button */}
                  <button
                    onClick={deleteProfilePicFunct}
                    className="btn btn-red py-5 bg-red-700"
                  >
                    Delete Picture
                  </button>
                </div>
                {/* <div className="">
                  <button className="btn-cancel">Cancel</button>
                </div> */}
              </div>
            </div>
          </div>
        </Drawer>
        <FooterDisplay />
      </div>
    </Spin>
  );
};

export default ProfileSettings;
